// import gqmsUtils from '@/views/gqmsCommUtil/api'; //공통함수 import
import { rootComputed } from '@/store/common/helpers';
import { setLpad, setChartBgColor, setChartBdColor } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	dayCols_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let searcBfRslt = searcCuRslt - 1;
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let bfRsltLabel = searcBfRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY');
		let thisDt = moment().format('MM');
		let searchYear = searcCuRslt.toString();
		let saleRegnNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001162')}`, //지역
			prop: 'saleRegnNm',
			width: '130px',
			align: 'left',
			sortable: false
		};
		let itemNm = {
			label: `${rootGetters['commonStore/getMessage_']('QWCC001215')}`, //항목
			prop: 'itemNm',
			minWidth: '100px',
			align: 'left',
			sortable: false
		};
		let bfRslt = {
			label: bfRsltLabel + `${rootGetters['commonStore/getMessage_']('QWCC001450')}`, //21년 실적
			prop: 'bfRslt',
			minWidth: '100px',
			align: 'right',
			sortable: false
		};
		let cuRslt = {
			label: cuRsltLabel + `${rootGetters['commonStore/getMessage_']('QWCC001450')}`, //22년 실적
			prop: 'cuRslt',
			minWidth: '100px',
			align: 'right',
			sortable: false
		};
		cols.push(saleRegnNm);
		cols.push(itemNm);
		cols.push(bfRslt);
		cols.push(cuRslt);
		let month =0;
		let pclProp = '';
		let labelMom = '';
		if (thisYear != searchYear) {
			for ( month = 1; month < 13; month++) {
				pclProp = 'mm' + setLpad(month, 2, '0');
				labelMom = setLpad(month, 2, '0');
				var newCol = {
					label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
					prop: pclProp,
					minWidth: '100px',
					align: 'right',
					sortable: false,
					labelClassName: searchYear + labelMom
				};
				cols.push(newCol);
			}
		} else {
			if (thisDt > 8) {
				for ( month = 1; month < 13; month++) {
					 pclProp = 'mm' + setLpad(month, 2, '0');
					 labelMom = setLpad(month, 2, '0');
					var newCol = {
						label: cuRsltLabel + labelMom + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
						prop: pclProp,
						minWidth: '100px',
						align: 'right',
						sortable: false,
						labelClassName: searchYear + labelMom
					};
					cols.push(newCol);
				}
			} else {
				for ( month = 0; month < 12; month++) {
					// let pclSearchDate = moment().subtract(8, 'M').add(month, 'M').format('YYYYMM');
					let pclSearchDate = moment(searchYear + '01').subtract(0, 'M').add(month, 'M').format('YYYYMM'); //수동테스트
					let pclYear = pclSearchDate.toString().substring(2, 4);
					let pclMonth = pclSearchDate.toString().substring(4, 6);
					let pclmonthm = month + 1;
					 pclProp = 'mm' + setLpad(pclmonthm, 2, '0');
					 labelMom = setLpad(pclmonthm, 2, '0');
					var newCol = {
						label:
							pclYear +
							`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
							' ' +
							pclMonth +
							`${rootGetters['commonStore/getMessage_']('SWCC000365')}`,
						prop: pclProp,
						minWidth: '100px',
						align: 'right',
						sortable: false,
						labelClassName: searchYear + labelMom
					};
					cols.push(newCol);
				}
			}
		}
		return cols;
	},
	//라인 차트
	LineChartLabel_: (state, getters, rootState, rootGetters) => {
		let cols = [];
		let searcCuRslt = Number(state.searchParams.searchDate);
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4) + `${rootGetters['commonStore/getMessage_']('QWCC001451')}` + ' ';
		let thisYear = moment().format('YYYY');
		let thisDt = moment().format('MM');
		let searchYear = searcCuRslt.toString();

		if (thisYear != searchYear) {
			for (let month = 1; month < 13; month++) {
				var newCol = cuRsltLabel + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
				cols.push(newCol);
			}
		} else {
			if (thisDt > 8) {
				for (let month = 1; month < 13; month++) {
					var newCol = cuRsltLabel + setLpad(month, 2, '0') + `${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
					cols.push(newCol);
				}
			} else {
				for (let month = 0; month < 12; month++) {
					// let pclSearchDate = moment().subtract(8, 'M').add(month, 'M').format('YYYYMM');
					let pclSearchDate = moment(searchYear + '01').subtract(0, 'M').add(month, 'M').format('YYYYMM');
					let pclYear = pclSearchDate.toString().substring(2, 4);
					let pclMonth = pclSearchDate.toString().substring(4, 6);
					var newCol =
						pclYear +
						`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
						' ' +
						pclMonth +
						`${rootGetters['commonStore/getMessage_']('SWCC000365')}`;
					cols.push(newCol);
				}
			}
		}
		return cols;
	},
	//라인 차트 데이터
	lineDataSet_: ({ graphLineChartInfo }) => {
		let cols = [];

		let colsData = [];
		let bgColor = [];
		let tmpLabel = '';
		let carCd = [];
		let idxScn = [];
		let tmpCarCd = [];
		let tmpIdxScn = [];
		let newCol = {};

		//데이터를 만든다.
		for (let i = 0; i < graphLineChartInfo.length; i++) {
			if (tmpIdxScn != graphLineChartInfo[i].idxScn) {
				idxScn.push(graphLineChartInfo[i].idxScn);
				tmpIdxScn = graphLineChartInfo[i].idxScn;
			}
		}

		for (let j = 0; j < idxScn.length; j++) {
			for (let y = 1; y <= 12; y++) {
				//console.log('이게뭐냐>????', graphLineChartInfo[j]['mm0' + y]);
				if (y < 10) {
					colsData.push(graphLineChartInfo[j]['mm0' + y]);
					tmpLabel = graphLineChartInfo[j].idxScn;
				} else {
					colsData.push(graphLineChartInfo[j]['mm' + y]);
					tmpLabel = graphLineChartInfo[j].idxScn;
				}
			}

			let newCol = {
				label: tmpLabel,
				data: colsData,
				borderColor: setChartBdColor(j)
			};

			//데이터 및 라벨을 초기화해야됨.
			//console.log('값은와이?>>>>>', colsData);
			colsData = [];
			tmpLabel = '';
			cols.push(newCol);
		} // end j

		//console.log('값은와이?>>>>>', cols);

		return cols;
	},

	//바 차트
	stackedLabel_: (state, getters, rootState, rootGetters) => {
		let searcCuRslt = Number(state.searchParams.searchDate);
		let searcBfRslt = searcCuRslt - 1;
		let cuRsltLabel = searcCuRslt.toString().substring(2, 4);
		let bfRsltLabel = searcBfRslt.toString().substring(2, 4);
		let barbRsltLabel =
			bfRsltLabel +
			`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
			' ' +
			`${rootGetters['commonStore/getMessage_']('QWCC001450')}`;
		let barCuRsltLabel =
			cuRsltLabel +
			`${rootGetters['commonStore/getMessage_']('QWCC001451')}` +
			' ' +
			`${rootGetters['commonStore/getMessage_']('QWCC001450')}`;

		let labelArray = [];

		labelArray.push(barbRsltLabel);
		labelArray.push(barCuRsltLabel);

		return labelArray;
	},

	//바 차트 데이터
	stackedDataSet_: ({ graphBarStackChartInfo }) => {
		let cols = [];

		for (let i = 0; i < graphBarStackChartInfo.length; i++) {
			let idxScn = graphBarStackChartInfo[i].idxScn;
			let bfCnt = graphBarStackChartInfo[i].bfCnt;
			let cuCnt = graphBarStackChartInfo[i].cuCnt;
			let cuYy = graphBarStackChartInfo[i].cuYy;
			let newCol = {
				type: 'bar',
				data: [bfCnt, cuCnt],
				dataKey: [idxScn],
				backgroundColor: setChartBgColor(i)
				//borderColor: setChartBdColor(i),
				//borderWidth: 1
			};
			cols.push(newCol);
		}

		return cols;
	},
	chartlcYMaxVal_: state => {
		//추가
		return Number(state.lcMaxVal);
	},
	chartBcYMaxVal_: state => {
		//추가
		return Number(state.bcMaxVal);
	}
};
